import { useEffect, useState } from "react";
import SubscriptionService from "services/SubscriptionService";
import SubscriptionVerificationService from "services/SubscriptionVerificationService";

interface UseSubscriptionCheckOptions {
  userId: string | null;
  isAnonymous?: boolean;
  onInvalid?: () => void;
}

export function useSubscriptionCheck({
  userId,
  isAnonymous = false,
  onInvalid,
}: UseSubscriptionCheckOptions) {
  const [isCheckingSubscription, setIsCheckingSubscription] = useState(true);
  const [isSubscriptionValid, setIsSubscriptionValid] = useState<
    boolean | null
  >(null);

  useEffect(() => {

    console.log("67 dbg 0")
    console.log("🔐 Checking subscription-details " + userId);
    const checkSubscription = async () => {

      if (!SubscriptionService.isInitialized && userId) {
        try {
          await SubscriptionService.initialize();
        } catch (error) {
          console.warn("⚠️ SubscriptionService initialization failed:", error);
        }
      }

      console.log("67 dbg 1")


      // Verify subscription-details (Stripe via cloud function)
      try {
        const verification =
          await SubscriptionVerificationService.verifySubscription({
            uid: userId,
          });

        if (!verification.isValid) {
          console.log(
            "🔐 SubscriptionOverviewPage check failed:",
            verification.reason
          );
          setIsSubscriptionValid(false);

          // Call custom handler if provided
          if (onInvalid) {
            onInvalid();
          }
          return;
        }

        console.log("✅ SubscriptionOverviewPage verified and valid");
        setIsSubscriptionValid(true);
      } catch (error) {
        console.error("❌ Error checking subscription-details:", error);
        setIsSubscriptionValid(false);

        // Call custom handler if provided
        if (onInvalid) {
          onInvalid();
        }
      } finally {
        setIsCheckingSubscription(false);
      }
    };


    console.log("67 dbg 2")

    // Only check if we have a userId (user is logged in)
    if (userId) {
      checkSubscription();
    } else {
      setIsCheckingSubscription(false);
      setIsSubscriptionValid(null);
    }

    console.log("67 dbg 3")

  }, [userId, isAnonymous, onInvalid]);

  return { isCheckingSubscription, isSubscriptionValid };
}
